/**
 * Constants used in by the Scheduling Grid
 */
export default {
    /**
     * The width (in px) of the timestrip in the scheduling grid
     */
    defaultTimeStripWidth: 50,

    /**
     * The width (in px) of the timestrip when the time zone header string overflows the default width
     */
    timeStripTimeZoneOverflowWidth: 60,
};
